@if (errors()) {
  <div class="errors">
    @for (error of [(errors()! | keyvalue)[0]]; track error.key) {
      <span class="errors__item error">
        {{ errorMessages?.[error.key]?.(error.value) }}
      </span>
    }
  </div>
}
